import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=4633d85e&scoped=true&"
import script from "./no-results.vue?vue&type=script&lang=js&"
export * from "./no-results.vue?vue&type=script&lang=js&"
import style0 from "./no-results.vue?vue&type=style&index=0&id=4633d85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4633d85e",
  null
  
)

export default component.exports